var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconToggleNotificationEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,19.828c-1.4,0-2.707-1.057-3.5-2.828H2.015A2.018,2.018,0,0,1,0,14.984V14.61a2.978,2.978,0,0,1,.558-1.742l1.005-1.407a1,1,0,0,0,.186-.581V6.25a6.25,6.25,0,0,1,12.5,0v4.63a1.008,1.008,0,0,0,.186.581l1,1.406A2.99,2.99,0,0,1,16,14.61v.374A2.018,2.018,0,0,1,13.984,17H11.5C10.707,18.771,9.4,19.828,8,19.828ZM6.386,17A2.106,2.106,0,0,0,8,18.162,2.106,2.106,0,0,0,9.613,17ZM8,2A4.255,4.255,0,0,0,3.75,6.25v4.63a2.983,2.983,0,0,1-.561,1.745l-1,1.4A.993.993,0,0,0,2,14.61v.374L13.984,15,14,14.61a1,1,0,0,0-.187-.581l-1-1.4a2.987,2.987,0,0,1-.559-1.744V6.25A4.255,4.255,0,0,0,8,2Z",
    transform: "translate(0)",
    fill: "#091119"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggleNotificationEmpty);
export default __webpack_public_path__ + "static/media/Icon-Toggle-Notification-Empty.b2a6c5b96c7ada3f960635da32c5948a.svg";
export { ForwardRef as ReactComponent };